module.exports = __webpack_public_path__ + "static/media/lowcarb.9a697758.jpg";